var priceText = document.querySelector('.product-price--compare').innerText;
if (priceText) {
    // Create a style element
    var style = document.createElement('style');
    document.head.appendChild(style);
    
    // Add a CSS rule to the style element
    style.sheet.insertRule('lb-product-page-cross-sell-ew { display: none; }', 0);
}
